/**
 * Team colours — brand-aware since ADR-063.
 *
 * These constants ARE the CSS variables: they carry `var(--team-home)` /
 * `var(--team-away)` from `styles/tokens.css`, which the
 * TenantConfigProvider overrides on `:root` per tenant via
 * runtimeConfig.brand.tokens. The old Phase 0b hex literals survive only
 * as `var()` fallbacks, so an unbranded context paints pixel-identical
 * to before.
 *
 * IMPORTANT — application context: a `var()` string is valid ONLY in CSS
 * contexts (inline `style` objects, CSS properties). SVG presentation
 * ATTRIBUTES (`fill=` / `stroke=` / `stop-color=` as React props on svg
 * elements) do NOT resolve `var()`. Any SVG consumer must paint via
 * `style={{ fill: color }}` / `style={{ stroke: color }}` instead of the
 * attribute.
 */

export const TEAM_HOME_COLOR = 'var(--team-home, #1976d2)';
export const TEAM_AWAY_COLOR = 'var(--team-away, #f47b1f)';
